module.exports = __webpack_public_path__ + "img/bluetooth_disabled.8324dc2e.svg";